import { render, staticRenderFns } from "./designSelector.vue?vue&type=template&id=ecdce0fe&scoped=true&"
import script from "./designSelector.vue?vue&type=script&lang=js&"
export * from "./designSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdce0fe",
  null
  
)

export default component.exports